import { Check, Copy01 } from "@untitledui/icons";
import { ButtonUtility } from "@/components/base/buttons/button-utility";
import { useClipboard } from "@/hooks/use-clipboard";

/** A value to take elsewhere, such as the id an administrator is granted by. */
export function CopyField({ label, value }: { label: string; value: string }) {
  const { copied, copy } = useClipboard();
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm font-medium text-secondary">{label}</span>
      <div className="flex items-center gap-2 rounded-lg bg-secondary py-1.5 pr-1.5 pl-3 ring-1 ring-secondary ring-inset">
        <code className="min-w-0 flex-1 truncate font-mono text-sm text-secondary">{value}</code>
        <ButtonUtility size="xs" color="tertiary" tooltip={copied ? "已复制" : "复制"} icon={copied ? Check : Copy01} onClick={() => void copy(value)} />
      </div>
    </div>
  );
}
